import { _invert } from '@naturalcycles/js-lib'
import { EU_COUNTRIES, ProductKey, thermometerKeys } from '@naturalcycles/shared'
import { env } from '@src/environments/environment.js'
import { getState } from '../srv/store.service'

export const getOuraShippingDisclaimerRange = (country: string): string => {
  if (country === 'US' || EU_COUNTRIES.includes(country)) return '4-14'
  return '5-16'
}

export const measuringDeviceList = [
  ProductKey.APPLE_WATCH,
  ...thermometerKeys,
  ProductKey.OURA_RING_DISCOUNT,
]

/**
 * Our default IAP product keys.
 */
export const IAP_PRODUCT_KEYS_DEFAULT: Partial<Record<ProductKey, string>> = {
  [ProductKey.YEAR]: `${env.appleBundleIdentifier}.yearly3`,
  [ProductKey.MONTH]: `${env.appleBundleIdentifier}.monthly3`,
  [ProductKey.ROLLING_TRIAL_7DAYS]: `${env.appleBundleIdentifier}.trial2`,
}

/**
 * Our IAP product keys, but with the YEAR and MONTH keys replaced with the plans
 * that have ~30% higher prices. The plans with the higher prices are used to compensate for the
 * IAP fee that apple charges. Which plans are used is controlled by the `appleTaxEnabled` remote config.
 */
export const IAP_PRODUCT_KEYS_WITH_IAP_FEE: Partial<Record<ProductKey, string>> = {
  ...IAP_PRODUCT_KEYS_DEFAULT,
  [ProductKey.YEAR]: `${env.appleBundleIdentifier}.yearly4`,
  [ProductKey.MONTH]: `${env.appleBundleIdentifier}.monthly4`,
}

export const IAP_PRODUCT_BY_NAME = {
  ..._invert(IAP_PRODUCT_KEYS_DEFAULT),
  ..._invert(IAP_PRODUCT_KEYS_WITH_IAP_FEE),
}

export function getDefaultThermometer(): ProductKey {
  const { items } = getState().product

  if (items.some(i => i.key === ProductKey.T3_THERMOMETER)) {
    return ProductKey.T3_THERMOMETER
  }
  if (items.some(i => i.key === ProductKey.BT_THERMOMETER)) {
    return ProductKey.BT_THERMOMETER
  }
  return ProductKey.THERMOMETER
}
